export default __webpack_public_path__ + "static/media/icon_gh_provider.50d205d5.svg";